module.exports = __webpack_public_path__ + "static/media/result-white.6a30d08c.svg";